import { CanActivate, GuardResult, MaybeAsync } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { UserStateService } from '../../core/services/user.state.service';
import { NavigationService } from '../../core/services/navigation.service';
import { PATHS } from '../models/paths';
import { RouterStateService } from '../../core/services/router-state.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedGuard implements CanActivate {
  private readonly userStateService = inject(UserStateService);
  private readonly routerStateService = inject(RouterStateService);
  private readonly navigationService = inject(NavigationService);

  public canActivate(): MaybeAsync<GuardResult> {
    if (this.userStateService.user()) {
      return true;
    } else {
      this.routerStateService.redirectUrl.set(document.URL);
      void this.navigationService.navigate(PATHS.signIn());
      return false;
    }
  }
}
